/**
 * 全局地址/哈希/时间格式化插件
 *
 * 使用方式（模板中）：
 *   {{ $shortHash(hash) }}     — 哈希：前12位 + ...
 *   {{ $shortAddr(address) }}  — 地址：前6 + ... + 后4
 *   {{ $formatTime(ts) }}      — 时间戳：秒/毫秒自动识别 → "YYYY-MM-DD HH:mm"
 */

import dayjs from "dayjs";

export default {
  install(Vue) {
    // 哈希格式化：前12位 + ...
    Vue.prototype.$shortHash = function (hash) {
      if (!hash) return "--";
      const s = String(hash);
      return s.length > 12 ? s.slice(0, 12) + "..." : s;
    };

    // 地址格式化：前6 + ... + 后4
    Vue.prototype.$shortAddr = function (addr) {
      if (!addr) return "--";
      const s = String(addr);
      return s.length > 12 ? s.slice(0, 6) + "..." + s.slice(-4) : s;
    };

    // 时间戳格式化：自动识别秒级/毫秒级
    //   {{ $formatTime(1786014772) }}                 → "2026-08-04 11:43"
    //   {{ $formatTime(1786014772000, "YYYY-MM-DD") }} → "2026-08-04"
    Vue.prototype.$formatTime = function (timestamp, format = "YYYY-MM-DD HH:mm") {
      if (timestamp === null || timestamp === undefined || timestamp === "") {
        return "";
      }
      // 已是 "YYYY-MM-DD ..." 格式的字符串则原样返回
      if (typeof timestamp === "string" && timestamp.indexOf("-") > -1) {
        return timestamp;
      }
      const num = Number(timestamp);
      if (!num || Number.isNaN(num)) return "";
      // 毫秒级（> 1e12）直接用，否则视为秒级 *1000
      const ms = num > 1000000000000 ? num : num * 1000;
      const d = dayjs(ms);
      if (!d.isValid()) return "";
      return d.format(format);
    };
  },
};
